import instance from './DefaultApi';

export default class DashboardService {
    ControllerName = 'Dashboard';

    // get dashboard data
    GetDashboardData(data) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDashboardData`, data).then(res => res)
    }
}